var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.09,4.05C25.82-.13,15.91,1.27,9.14,7.33l-1.32-1.32c-.26-.26-.71-.14-.81,.22l-1.82,6.8c-.1,.36,.23,.69,.59,.59l6.8-1.82c.36-.1,.48-.55,.22-.81l-1.33-1.33c5.78-5.07,14.15-6.22,21.15-2.68,7.73,3.91,11.85,12.54,10.03,20.99l3.21,.69c2.13-9.91-2.7-20.03-11.76-24.61Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.43,32.12c-1.66,.43-3.52,.06-4.64-.92-.59-.52-.98-1.22-1.13-2.02l-3.23,.59c.28,1.51,1.05,2.9,2.19,3.89,1.02,.89,2.33,1.48,3.73,1.75v2.96h3.28v-2.96c.21-.04,.42-.07,.62-.12,2.4-.63,4.21-2.21,4.96-4.34,1.85-5.25-3.4-7.66-6.53-9.11-.7-.32-1.36-.63-1.88-.92-1.65-.92-2.37-1.9-2.13-2.91,.25-1.07,1.3-2.04,2.45-2.26,1.78-.33,3.66,.56,4.39,2.08l2.95-1.43c-.93-1.92-2.76-3.26-4.83-3.77v-3.02h-3.28v2.95c-2.34,.51-4.33,2.41-4.87,4.68-.34,1.47-.32,4.26,3.72,6.52,.63,.35,1.35,.68,2.11,1.03,3.92,1.8,5.54,2.96,4.81,5.04-.53,1.49-1.91,2.05-2.69,2.25Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.97,34.64l-6.81,1.82c-.36,.1-.48,.54-.22,.8l1.31,1.31c-5.76,4.86-13.98,5.92-20.87,2.43-7.73-3.91-11.85-12.54-10.03-20.99l-3.21-.69C.02,29.24,4.85,39.36,13.91,43.94c3.21,1.62,6.66,2.41,10.08,2.41,5.29,0,10.48-1.89,14.59-5.45l1.35,1.35c.26,.26,.71,.14,.8-.22l1.82-6.81c.1-.36-.23-.68-.59-.59Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransactions);
export default __webpack_public_path__ + "static/media/icon_transactions.68fce3388cb7833192b48a307f84639e.svg";
export { ForwardRef as ReactComponent };